<div class="tags-input">
    <span class="tags-input__tag label label-primary" *ngFor="let tag of ARR_tags">
        {{BOO_objectTags ? tag[STR_displayField] : tag}}
	    <span
		    *ngIf="isDeletable(tag)"
		    role="button"
		    class="tags-input__tag-remove-btn"
		    (click)="removeTag(tag)"
		    (touch)="removeTag(tag)">
            <span aria-hidden="true"><i aria-hidden="true" class="fa fa-remove"></i></span>
            <span class="sr-only">{{'oFormList.sClose'|translate}}</span>
        </span>
    </span>
	<input
		*ngIf="ARR_options === null"
		class="tags-input__input-field"
		type="text"
		placeholder="{{getPlaceHolder()}}"
		name="tags"
		(keydown.enter)="addTag(tagInput)"
		(keydown.space)="(!with_space)?addTag(tagInput):null"
		(blur)="addTag(tagInput)"
		(keydown.backspace)="removeLastTag(tagInput)"
		[disabled]="disableField()"
		[attr.minlength]="minlength"
		[attr.maxlength]="maxlength"
		pattern="{{pattern}}"
		[required]="required"
		#tagInput
	/>
</div>
